export const acceptedMIMETypes = [
  "vscode-editor-data",
  "blocknote/html",
  "text/html",
  "text/plain",
  "Files",
] as const;
